class EventDispatcher {
  listeners = {}

  addEventListener<T = any>(type: string, listener: (event: T) => void): void {
    if (!this.listeners[type]) {
      this.listeners[type] = []
    }
    if (this.listeners[type].indexOf(listener) === -1) {
      this.listeners[type].push(listener)
    }
  }

  /** 不传 listener 时清空该 type 下全部监听；传入则只移除对应回调 */
  removeEventListener<T = any>(type: string, listener?: (event: T) => void) {
    if (!this.listeners[type]) return
    if (listener) {
      const arr = this.listeners[type] as ((event: T) => void)[]
      const idx = arr.indexOf(listener)
      if (idx !== -1) arr.splice(idx, 1)
    } else {
      this.listeners[type] = []
    }
  }

  dispatchEvent(type: string, data: any) {
    const listenerArray = this.listeners[type] || []
    if (listenerArray.length === 0) return
    listenerArray.forEach(listener => {
      listener.call(this, data)
    })
  }
}

export const wsEvent = new EventDispatcher()
